<div [class.drag-container]="!expandLayerFeatures && !selectedFeature" [class.selected-item]="selected">
  <div class="d-flex align-items-center">
    <div >
      <mat-checkbox
        *ngIf="!multiSelectMode && !expandLayerFeatures && !selectedFeature"
        [checked]="layer?.visible"
        [value]="layer?.id"
        (change)="changeVisibility($event)"
        [disabled]="!layer?.enabled"></mat-checkbox>

      <mat-checkbox
        *ngIf="multiSelectMode && !expandLayerFeatures && !selectedFeature"
        [checked]="selected"
        [value]="layer?.id"
        (change)="selectLayer.emit(layer)"
        [disabled]="false"></mat-checkbox>

      <button class="back-icon" matIconButton aria-label="Move back" *ngIf="(expandLayerFeatures || selectedFeature) && !multiSelectMode" (click)="moveBack()">
        <mat-icon>keyboard_backspace</mat-icon>
      </button>
    </div>
    <div class="flex-grow-1 overflow-hidden d-flex align-items-center">
        <span class="text-truncate mat-font-body-md" [class.highlight]="this.highlightLayer" title="{{ layer?.name }}">
          {{ layer?.name }}
        </span>
      <button *ngIf="isGroupLayer && !multiSelectMode" class="back-icon" matIconButton (click)="toggleGroupExpand()">
        <mat-icon>{{ expandedGroup ? 'expand_less' : 'expand_more' }}</mat-icon>
      </button>
      <span *ngIf="!selectedFeature && layerFeatureFilter" class="mat-font-body-sm filter-features">{{ features.length }} results</span>
      <div *ngIf="selectedFeature" class="d-flex feature-controller align-items-center ">
        <button  matIconButton aria-label="Move back" [hidden]="featureIndex + 1 === 1" (click)="previousFeature()">
          <mat-icon>navigate_before</mat-icon>
        </button>
        <span class="mat-font-label-md">{{ featureIndex + 1 }} of {{ features.length }}</span>
        <button matIconButton aria-label="Move forward" [hidden]="featureIndex + 1 === features.length" (click)="nextFeature()">
          <mat-icon>navigate_next</mat-icon>
        </button>
      </div>
      <mat-icon class="eye-icon" *ngIf="!this.selectedFeature && !expandLayerFeatures && focus">remove_red_eye</mat-icon>
    </div>
    <div class="d-flex align-items-center">
      <mat-icon id="security-icon" matTooltip="This data is stored in your browser." matTooltipPosition="above">verified_user</mat-icon>
      <button class="layer-menu-icon" matIconButton [matMenuTriggerFor]="layerMenu" [disabled]="multiSelectMode">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #layerMenu="matMenu">
        <button mat-menu-item (click)="editLayer()" *ngIf="checkEditAvailable() && !multiSelectMode">
          <span>Edit</span>
        </button>
        <button id="overlay-remove-layer-menu-option" mat-menu-item (click)="removeLayer()" *ngIf="!multiSelectMode">
          <span>Remove</span>
        </button>
        <button mat-menu-item (click)="fit()" [disabled]="!layer?.visible" *ngIf="layer?.bbox && !multiSelectMode">
          <span>{{ "Highlight on map" }}</span>
        </button>
          @if ((flagService.getFlags$() | async)?.[FeatureFlags.AI_AGENTS]){
              <button mat-menu-item (click)="viewLayerData()" *ngIf="hasGeoJsonFeatures() && !multiSelectMode">
                  <span>View data</span>
              </button>
              <button mat-menu-item (click)="editAdvancedStyle()" *ngIf="hasGeoJsonFeatures() && !multiSelectMode">
                  <span>Edit Style</span>
              </button>
              <button mat-menu-item (click)="showLegend()" *ngIf="layer?.styleDefinition && !multiSelectMode">
                  <span>Show legend</span>
              </button>
              <button mat-menu-item (click)="openVlmPanel()" *ngIf="layer?.layerGroup === 'vlm' && !multiSelectMode">
                  <span>View analysis</span>
              </button>
              <button mat-menu-item (click)="openEmbeddingsPanel()" *ngIf="layer?.layerGroup === 'embeddings' && !multiSelectMode">
                  <span>View analysis</span>
              </button>
          }

        <div
          [matTooltip]="
            !viewerService.enablePropertiesSubject?.getValue()
              ? 'Property information requires access to Elements. To enable this for your organization, learn more here: ' +
                viewerConfigurationService.getViewerConfiguration()?.propertyAttributesUrl
              : ''
          ">
          <button
            id="retrieve-property-info-option"
            mat-menu-item
            (click)="retrievePropertyInformation()"
            *ngIf="checkPIF() && !multiSelectMode"
            [disabled]="!viewerService.enablePropertiesSubject.getValue()">
            <span>Retrieve property information</span>
            <mat-icon *ngIf="!viewerService.enablePropertiesSubject?.getValue()" class="lock-icon">lock</mat-icon>
          </button>
        </div>
        <div
          [matTooltip]="
            !mapService.getCoreMap()?.isDamageAssessmentAllowed()
              ? 'Damage assessment requires access to Elements. To enable this for your organization, learn more here: ' +
                viewerConfigurationService.getViewerConfiguration()?.damageAssessmentUrl
              : ''
          "
          matTooltipClass="non-truncated-tooltip">
          <button
            mat-menu-item
            (click)="retrieveDamageAssessment()"
            [disabled]="!mapService.getCoreMap()?.isDamageAssessmentAllowed() || !(this.viewerService.projectsPopulated$ | async)"
            *ngIf="checkPIF() && !multiSelectMode">
            <span>Retrieve damage assessment</span>
            <mat-icon *ngIf="!mapService.getCoreMap()?.isDamageAssessmentAllowed()" class="lock-icon">lock</mat-icon>
          </button>
        </div>
      </mat-menu>
    </div>
  </div>
  <div *ngIf="layer?.customOverlayProperties && !selectedFeature">
    <div class="expand-feature-button" *ngIf="!expandLayerFeatures">
      <button (click)="expandFeatureslist()" [disabled]="multiSelectMode">
        Open list view
        <mat-icon>keyboard_arrow_right</mat-icon>
      </button>
      <mat-divider class="divider"></mat-divider>
    </div>
    <div class="row feature-list" *ngIf="expandLayerFeatures">
      <div *ngFor="let feature of features" class="feature-row">
        <custom-pin
          *ngIf="feature.geometry?.type === 'Point'"
          class="csv-pin"
          [height]="20"
          [width]="13"
          [fillColor]="feature.style ? feature.style.fillColor : this.getFillColorLayer()"></custom-pin>
        <phoenix-feature-data
          class="feature"
          [feature]="feature"
          [focusedFeature]="focusedFeature"
          (selectFeature)="onSelectedFeature($event)"
          [primaryField]="layer?.customOverlayProperties.primaryField"
          [secondaryField]="layer?.customOverlayProperties.secondaryField"
          [layerFeatureFilter]="layerFeatureFilter"></phoenix-feature-data>
      </div>
    </div>
  </div>
  <div *ngIf="selectedFeature && !multiSelectMode">
    <phoenix-feature-detail [layer]="layer" [additionalFeatures]="this.additionalFeatures" [feature]="selectedFeature"></phoenix-feature-detail>
  </div>
  <div *ngIf="isGroupLayer && expandedGroup && layer?.childs?.length" class="d-flex flex-column">
    <phoenix-user-layer-data
      *ngFor="let child of layer.childs"
      [layer]="child"
      [isChild]="true"
      class="ps-3">
    </phoenix-user-layer-data>
  </div>
</div>
